import { useMemo, useState } from "react";
import { todayGossip, type GossipItem } from "@/mocks/gossip";

const levelStyle: Record<GossipItem["level"], string> = {
  爆: "bg-primary-600 text-background-50",
  热: "bg-accent-500 text-primary-950",
  温: "bg-secondary-200 text-secondary-900",
};

const levelBorder: Record<GossipItem["level"], string> = {
  爆: "border-primary-400 bg-primary-100",
  热: "border-accent-400 bg-accent-100",
  温: "border-secondary-300 bg-secondary-100",
};

const cats = ["全部", "综艺", "明星", "影视", "社会", "网红"];

export default function TodayGossip() {
  const [active, setActive] = useState("全部");
  const list = useMemo(
    () =>
      active === "全部"
        ? todayGossip
        : todayGossip.filter((t) => t.category === active),
    [active]
  );

  return (
    <section
      id="today"
      className="scroll-mt-24 w-full bg-background-50 py-12 md:py-16"
    >
      <div className="mx-auto w-full max-w-[1320px] px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="flex items-center gap-2 text-xs font-semibold tracking-wide text-primary-600">
              <span className="h-3 w-1 rounded-full bg-primary-500" />
              TODAY · 实时更新
            </p>
            <h2 className="mt-2 font-display text-2xl font-bold text-foreground-950 md:text-3xl">
              今日瓜点
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              按时间倒序汇总，热门话题无需再跨平台手动翻。
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-1.5 rounded-full bg-background-100 p-1">
            {cats.map((c) => (
              <button
                key={c}
                type="button"
                onClick={() => setActive(c)}
                className={`whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-medium transition-colors ${
                  active === c
                    ? "bg-primary-600 text-background-50"
                    : "text-foreground-600 hover:bg-background-200 hover:text-foreground-800"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        <div className="relative mt-8 border-l border-background-200 pl-5 md:pl-8">
          <span className="absolute -left-[5px] top-1 h-2.5 w-2.5 rounded-full bg-primary-500" />
          {list.map((item) => (
            <article
              key={item.title}
              className="group relative pb-7 pl-2 md:pb-8 md:pl-4"
            >
              <span
                className={`absolute -left-[27px] top-1.5 h-3 w-3 rounded-full border-2 md:-left-[41px] ${levelBorder[item.level]}`}
              />
              <div className="flex flex-col gap-2 rounded-lg border border-background-200/80 bg-background-50 p-4 transition-all duration-300 group-hover:border-primary-200 group-hover:shadow-soft md:p-5">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="w-10 font-label text-sm font-bold text-primary-600">
                    {item.time}
                  </span>
                  <span
                    className={`flex h-5 w-5 items-center justify-center rounded text-[11px] font-bold ${levelStyle[item.level]}`}
                  >
                    {item.level}
                  </span>
                  <span className="rounded bg-secondary-100 px-2 py-0.5 text-xs text-secondary-800">
                    {item.category}
                  </span>
                  <span className="ml-auto flex items-center gap-1 text-xs text-foreground-400">
                    <i className="ri-fire-line h-3.5 w-3.5 flex items-center justify-center text-accent-500" />
                    热度 {item.heat}
                  </span>
                </div>
                <h3 className="font-label text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
                  {item.title}
                </h3>
                <p className="text-sm leading-relaxed text-foreground-600">
                  {item.summary}
                </p>
              </div>
            </article>
          ))}
          <div className="flex items-center gap-2 py-2 pl-2 text-xs text-foreground-400">
            <i className="ri-loader-4-line h-4 w-4 flex items-center justify-center animate-spin text-primary-500" />
            今日瓜点持续刷新中，稍后会再有更新……
          </div>
        </div>
      </div>
    </section>
  );
}